import React from 'react';
export function Footer() {
  return <footer className="bg-[#3d4f5c] text-white py-12 border-t border-white/10" data-id="element-71" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72" data-mp="3gg10g6ubc3z8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-73" data-mp="32o4d0g3lai96">
          <div className="flex items-center gap-3" data-id="element-74" data-mp="36pfu1x8edv5r">
            <img src="https://cdn.magicpatterns.com/uploads/r2Qpm7TVH9yfhMg7exMXJN/IMG_2424.png" alt="Fix & Finish Logo" className="h-10 w-auto brightness-0 invert" data-id="element-75" data-mp="36q900vzj8gmu" />
            <div className="flex flex-col" data-id="element-76" data-mp="36muiocgf6ul">
              <span className="text-lg font-bold leading-none" data-id="element-77" data-mp="3levhp4cmtkh8">
                FIX & FINISH
              </span>
              <span className="text-[10px] font-medium tracking-wider text-gray-400" data-id="element-78" data-mp="3qcds6z6as7rc">
                PDX CONTRACTING
              </span>
            </div>
          </div>

          <div className="flex gap-8 text-sm text-gray-300" data-id="element-79" data-mp="2ey0a6ay86mj8">
            <a href="#services" className="hover:text-white transition-colors" data-id="element-80" data-mp="2ezl4q0kji5h3">
              Services
            </a>
            <a href="#why-us" className="hover:text-white transition-colors" data-id="element-81" data-mp="3lbdc0r0ka5kr">
              About
            </a>
            <a href="#contact" className="hover:text-white transition-colors" data-id="element-82" data-mp="3v7gfc075ga9a">
              Contact
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-83" data-mp="3q8dkf8kvvkf1">
              Privacy
            </a>
          </div>

          <div className="text-sm text-gray-400" data-id="element-84" data-mp="81pejgi0et8b">
            © {new Date().getFullYear()} Fix & Finish PDX. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}